module.exports = __webpack_public_path__ + "static/media/file-logo-white.0f8ee88f.svg";